module.exports = __webpack_public_path__ + "img/icon-cost-usa.31a2e670.svg";